import { PaymentMethod, PaymentPlan } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { PaymentMethodImageType } from '@mews/business-components';
import { LocalizedEnum, lt } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import PaymentCardIcon from '../../../../../components/commander-ui/PaymentCardIcon';
import { PaymentMethodIcon } from '../../../../../components/commander-ui/PaymentMethodIcon';
import { PaymentMethodSidebarLink } from '../PaymentMethods/PaymentMethodSidebarLink';

export const PaymentMethodType = ({
    paymentMethodData,
}: {
    paymentMethodData: NonNullable<PaymentPlan['paymentMethodData']>;
}) => {
    if (paymentMethodData.discriminator === PaymentMethod.PaymentCard) {
        const { lastDigits, type } = paymentMethodData.value;
        return (
            <Stack>
                <PaymentCardIcon type={type} width={24} />
                {UnicodeEntity.NoBreakSpace}
                <PaymentMethodSidebarLink
                    paymentMethod={PaymentMethod.PaymentCard}
                    paymentMethodId={paymentMethodData.value.id}
                    sidebarTitle={
                        <Stack itemAlignment="center">
                            <LocalizedEnum prefix="PaymentCardType" value={type} />
                            {UnicodeEntity.NoBreakSpace}
                            {lastDigits}
                        </Stack>
                    }
                    linkTitle={lastDigits}
                />
            </Stack>
        );
    }

    if (paymentMethodData.discriminator === PaymentMethod.SepaDirectDebit) {
        const { lastDigits } = paymentMethodData.value;
        return (
            <Stack>
                <PaymentMethodIcon type={PaymentMethodImageType.SepaDirectDebit} small />
                {UnicodeEntity.NoBreakSpace}
                <PaymentMethodSidebarLink
                    paymentMethod={PaymentMethod.SepaDirectDebit}
                    paymentMethodId={paymentMethodData.value.id}
                    sidebarTitle={
                        <Stack itemAlignment="center">
                            {lt('Sepa')}
                            {UnicodeEntity.NoBreakSpace}
                            {lastDigits}
                        </Stack>
                    }
                    linkTitle={lastDigits}
                />
            </Stack>
        );
    }

    return null;
};
